import { render, staticRenderFns } from "./VetrinaFornitore.vue?vue&type=template&id=73361b10&scoped=true"
import script from "./VetrinaFornitore.vue?vue&type=script&lang=js"
export * from "./VetrinaFornitore.vue?vue&type=script&lang=js"
import style0 from "./VetrinaFornitore.vue?vue&type=style&index=0&id=73361b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73361b10",
  null
  
)

export default component.exports